import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/dialog/dialogactionsview
 */
import { FocusTracker, KeystrokeHandler } from '@ckeditor/ckeditor5-utils';
import ButtonView from '../button/buttonview.js';
import View from '../view.js';
import ViewCollection from '../viewcollection.js';
import FocusCycler from '../focuscycler.js';
import '../../theme/components/dialog/dialogactions.css';
/**
 * A dialog actions view class. It contains button views which are used to execute dialog actions.
 */
var DialogActionsView = /*#__PURE__*/function (_View) {
  _inherits(DialogActionsView, _View);
  var _super = _createSuper(DialogActionsView);
  /**
   * @inheritDoc
   */
  function DialogActionsView(locale) {
    var _this;
    _classCallCheck(this, DialogActionsView);
    _this = _super.call(this, locale);
    _this.children = _this.createCollection();
    _this.keystrokes = new KeystrokeHandler();
    _this._focusTracker = new FocusTracker();
    _this._focusables = new ViewCollection();
    _this.focusCycler = new FocusCycler({
      focusables: _this._focusables,
      focusTracker: _this._focusTracker,
      keystrokeHandler: _this.keystrokes,
      actions: {
        // Navigate form fields backwards using the Shift + Tab keystroke.
        focusPrevious: 'shift + tab',
        // Navigate form fields forwards using the Tab key.
        focusNext: 'tab'
      }
    });
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-dialog__actions']
      },
      children: _this.children
    });
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(DialogActionsView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(DialogActionsView.prototype), "render", this).call(this);
      this.keystrokes.listenTo(this.element);
    }
    /**
     * Creates the button views based on the given definitions.
     * Then adds them to the {@link #children} collection and to the focus cycler.
     */
  }, {
    key: "setButtons",
    value: function setButtons(definitions) {
      var _this2 = this;
      var _iterator = _createForOfIteratorHelper(definitions),
        _step;
      try {
        var _loop = function _loop() {
          var definition = _step.value;
          var button = new ButtonView(_this2.locale);
          var property = void 0;
          button.on('execute', function () {
            return definition.onExecute();
          });
          if (definition.onCreate) {
            definition.onCreate(button);
          }
          for (property in definition) {
            if (property != 'onExecute' && property != 'onCreate') {
              button.set(property, definition[property]);
            }
          }
          _this2.children.add(button);
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this._updateFocusCyclableItems();
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "focus",
    value: function focus(direction) {
      if (direction === -1) {
        this.focusCycler.focusLast();
      } else {
        this.focusCycler.focusFirst();
      }
    }
    /**
     * Adds all elements from the {@link #children} collection to the {@link #_focusables} collection
     * and to the {@link #_focusTracker} instance.
     */
  }, {
    key: "_updateFocusCyclableItems",
    value: function _updateFocusCyclableItems() {
      var _this3 = this;
      Array.from(this.children).forEach(function (v) {
        _this3._focusables.add(v);
        _this3._focusTracker.add(v.element);
      });
    }
  }]);
  return DialogActionsView;
}(View);
export { DialogActionsView as default };